import { handleActions } from "redux-actions";
import { WARNING_REDIRECT } from "constants/action-types";
import { IAction } from "epics/base-epic";
import { LocationDescriptor } from "history";

export interface IWarningState {
    show: boolean;
    notify: boolean;
    showAgain: boolean;
    redirect: LocationDescriptor;
}

const initialState: IWarningState = {
    show: false,
    notify: false,
    showAgain: !sessionStorage.getItem("hide-redirect-warning"),
    redirect: null,
};

export const warning = handleActions<IWarningState, Partial<IWarningState>>(
    {
        [WARNING_REDIRECT.UPDATE]: (
            state: IWarningState,
            { payload }: IAction<Partial<IWarningState>>
        ): IWarningState => ({
            ...state,
            ...payload,
        }),
        [WARNING_REDIRECT.CLEAR]: (state: IWarningState): IWarningState => ({
            ...state,
            show: false,
            notify: false,
            redirect: null,
        }),
    },
    initialState
);
